import { LoyaltyRewardStatus } from '@onbeefapp/constants';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Confetti from '../../../assets/confetti.gif';
import StarList from '../../../assets/images/favorite.png';
import { useRefreshLoyaltyData } from '../../../queries/loyalty';
import { useAuthStore } from '../../../stores/login';
import { LoyaltyDetailWelcoming } from './LoyaltyDetailWelcoming';
import { useMerchantStore } from '../../../stores/merchant';

export const StandardLoyaltyDetail = () => {
  const merchant = useMerchantStore((state) => state.merchant);
  const user = useAuthStore((state) => state.user);

  const { mutateAsync: refreshLoyaltyData } = useRefreshLoyaltyData();
  const updateLoyalty = useAuthStore((state) => state.updateLoyalty);

  const userLoyalty = user?.loyalty_programmes?.find(
    (loyalty) => loyalty.merchant_id === merchant?.id,
  );

  const userProgress = userLoyalty?.reward?.redemption?.percentage ?? 0;

  const handleRefreshLoyalty = async () => {
    const data = await refreshLoyaltyData();
    if (data) {
      updateLoyalty(data);
    }
  };

  useEffect(() => {
    handleRefreshLoyalty();
  }, []);

  const giftAvailable =
    userLoyalty?.gift &&
    userLoyalty.gift?.redemption?.status !== LoyaltyRewardStatus.RESCUED;

  const alreadySubed = userLoyalty != null;

  const giftSubtitle = userLoyalty?.gift?.message || '';

  return alreadySubed ? (
    <div className="flex flex-col p-5 space-y-6 bg-white rounded-t-3xl">
      {(userLoyalty.gift?.redemption || userLoyalty.reward?.redemption) &&
        userProgress <= 100 &&
        userProgress > 0 && (
          <div className="flex flex-col gap-6">
            <div className="flex items-center gap-3 border-b border-gray-100 pb-4">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
                <span className="text-xl">👋</span>
              </div>
              <h2 className="text-xl font-semibold">Olá, {user?.name}!</h2>
            </div>

            <div className="space-y-4">
              {userLoyalty.gift?.redemption?.percentage <= 100 &&
                userLoyalty.gift?.redemption?.percentage > 0 &&
                (!userLoyalty.gift?.redemption ||
                  userLoyalty.gift?.redemption?.status !=
                    LoyaltyRewardStatus.RESCUED) && (
                  <div className="bg-gray-50 p-4 rounded-xl">
                    <div className="flex items-start gap-3 mb-4">
                      <img
                        src={StarList}
                        className="h-5 w-5 mt-1"
                        alt="Estrela"
                      />
                      <p className="font-medium text-gray-800">
                        {userLoyalty.gift?.redemption?.message ?? ''}
                      </p>
                    </div>
                    <Link
                      className="block w-full text-center bg-primary hover:bg-primary/90 transition-colors text-white p-3 rounded-xl font-semibold"
                      to="/"
                    >
                      {userLoyalty.gift?.redemption?.status ===
                      LoyaltyRewardStatus.TO_RESCUE
                        ? 'Resgatar meu prêmio'
                        : 'Fazer pedido'}
                    </Link>
                  </div>
                )}

              {userLoyalty.reward?.redemption?.percentage <= 100 &&
                userLoyalty.reward?.redemption?.percentage > 0 &&
                (!userLoyalty.reward?.redemption ||
                  userLoyalty.reward?.redemption?.status !=
                    LoyaltyRewardStatus.RESCUED) && (
                  <div className="bg-gray-50 p-4 rounded-xl">
                    <div className="flex items-start gap-3 mb-4">
                      <img
                        src={StarList}
                        className="h-5 w-5 mt-1"
                        alt="Estrela"
                      />
                      <p className="font-medium text-gray-800">
                        {userLoyalty.reward?.redemption?.message ?? ''}
                      </p>
                    </div>
                    <Link
                      className="block w-full text-center bg-primary hover:bg-primary/90 transition-colors text-white p-3 rounded-xl font-semibold"
                      to="/"
                    >
                      {userLoyalty.reward?.redemption?.status ===
                      LoyaltyRewardStatus.TO_RESCUE
                        ? 'Resgatar meu prêmio'
                        : 'Fazer pedido'}
                    </Link>
                  </div>
                )}
            </div>
          </div>
        )}

      {(userLoyalty?.reward?.redemption?.percentage === 0 ||
        userLoyalty?.gift?.redemption?.percentage === 0) &&
        (userLoyalty.gift?.redemption || userLoyalty.reward?.redemption) &&
        (userLoyalty.gift?.redemption?.status != LoyaltyRewardStatus.RESCUED ||
          userLoyalty.reward?.redemption?.status !=
            LoyaltyRewardStatus.RESCUED) && <LoyaltyDetailWelcoming />}

      {userProgress === 100 && (
        <div className="flex flex-col items-center gap-6 py-4">
          {userLoyalty.gift?.redemption?.status ===
          LoyaltyRewardStatus.RESCUED ? (
            <div className="bg-gray-50 p-6 rounded-xl text-center w-full shadow-sm">
              <p className="font-medium text-gray-800">
                {userLoyalty.gift?.redemption?.message ?? ''}
              </p>
            </div>
          ) : (
            <>
              <img src={Confetti} className="w-32 h-32" alt="Confetti" />
              {giftAvailable && (
                <div className="bg-gray-50 p-6 rounded-xl text-center w-full shadow-sm">
                  <p className="font-medium text-gray-800">{giftSubtitle}</p>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  ) : (
    <></>
  );
};
